<template>
    <ToolbarDropdown :is-locked="isLocked">
        <template v-slot:toggle>
            <img src="/default-images/whiteboard/tool-rect-outline.svg" />
        </template>
        <div class="bg-white p-1 flex gap-2 items-center justify-center">
            <div class="toolbar-group">
                <button
                    type="button"
                    @click="currentTool = 'rectOutline'"
                    :class="{ active: currentTool == 'rectOutline' }"
                >
                    <img
                        src="/default-images/whiteboard/tool-rect-outline.svg"
                    />
                </button>
                <button
                    type="button"
                    @click="currentTool = 'rect'"
                    :class="{ active: currentTool == 'rect' }"
                >
                    <img src="/default-images/whiteboard/tool-rect.svg" />
                </button>
            </div>
            <div class="sep"></div>
            <div class="toolbar-group">
                <button
                    type="button"
                    @click="currentTool = 'circleOutline'"
                    :class="{ active: currentTool == 'circleOutline' }"
                >
                    <img
                        src="/default-images/whiteboard/tool-circle-outline.svg"
                    />
                </button>
                <button
                    type="button"
                    @click="currentTool = 'circle'"
                    :class="{ active: currentTool == 'circle' }"
                >
                    <img src="/default-images/whiteboard/tool-circle.svg" />
                </button>
            </div>
        </div>
    </ToolbarDropdown>
</template>
<script setup>
import useWhiteboard from "../useWhiteboard";
const { currentTool, isLocked } = useWhiteboard();
</script>
